module.exports = __webpack_public_path__ + "static/media/customizedplan.8d5247e0.svg";